import { render, staticRenderFns } from "./gsZhaoping.vue?vue&type=template&id=8d245390&scoped=true&"
import script from "./gsZhaoping.vue?vue&type=script&lang=js&"
export * from "./gsZhaoping.vue?vue&type=script&lang=js&"
import style0 from "./gsZhaoping.vue?vue&type=style&index=0&id=8d245390&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d245390",
  null
  
)

export default component.exports